export default class Movie {
    constructor() {
        this.player = null;
    }

    init() {
        const $modalbtn = document.querySelector(".js-moviemodal_btn");

        if ($modalbtn !== null) {
            this.open();
        }
    }

    open() {
        const modalid = "movie";
        const tgtmodal = document.querySelector(
            `.js-modal[data-modalID=${modalid}]`
        );

       document.body.classList.add("-lock");
       tgtmodal && tgtmodal.classList.add("-active");

       // 劇場総集編対応
       tgtmodal && tgtmodal.classList.add("-compilation");
    }
}
